export default __webpack_public_path__ + "static/media/trash.40eeed92.svg";